import { getLocalDateString } from "./date";

export const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
};

export const getFirstDayOfMonth = (month, year) => {
    const firstDay = new Date(year, month, 1).getDay();

    return firstDay === 0 ? 6 : firstDay - 1;
};

export const getMonthName = (month) => {
    const months = [
    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
    ];
    return months[month];
};


export function getFilteredHabits(habits, selectedDate, filter) {
    if (!selectedDate) return [];

    const dateStr = getLocalDateString(selectedDate);

    const habitsForSelectedDate = habits.filter(habit => {
        const sel = new Date(selectedDate).setHours(0,0,0,0);
        const createdAt = new Date(habit.created_at).setHours(0,0,0,0);
        if (!habit.deadline) return sel >= createdAt;
        const deadline = new Date(habit.deadline).setHours(0,0,0,0);
        return sel >= createdAt && sel <= deadline;
    });

    return habitsForSelectedDate.filter(habit => {
        const done = !!habit.completedDates?.[dateStr];
        if (filter === "active")    return !done;
        if (filter === "completed") return done;
        if (filter === "withDate")  return !!habit.deadline && !done;
        return true;
    });
}

export function getHabitCountsByDate(habits, currentMonth, currentYear, daysInMonth) {
    const counts = {};
    if (!habits || habits.length === 0) return counts;

    for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(currentYear, currentMonth, day);
        const dateStr = getLocalDateString(date);

        const count = habits.filter(habit => {
            const createdAt = new Date(habit.created_at).setHours(0,0,0,0);
            const deadline = habit.deadline ? new Date(habit.deadline).setHours(0,0,0,0) : Infinity;
            const current = date.setHours(0,0,0,0);

            return current >= createdAt && current <= deadline;
        }).length;

        counts[dateStr] = count;
    }

    return counts;
}

export function getHabitCountsForDate(habits, selectedDate) {
    if (!selectedDate) return { active: 0, completed: 0, withDate: 0 };

    const dateStr = getLocalDateString(selectedDate);
    const sel = new Date(selectedDate).setHours(0,0,0,0);

    let active = 0, completed = 0, withDate = 0;

    habits.forEach(habit => {
        const createdAt = new Date(habit.created_at).setHours(0,0,0,0);
        const deadline = habit.deadline ? new Date(habit.deadline).setHours(0,0,0,0) : Infinity;
        const isInRange = sel >= createdAt && sel <= deadline;
        const done = !!habit.completedDates?.[dateStr];

        if (isInRange && !done) active++;
        if (isInRange && done) completed++;
        if (isInRange && habit.deadline && !done) withDate++;
    });

    return { active, completed, withDate };
}